<template>
  <div>
    <div class="ft-22-333">我的学习</div>
    <div class="se-flex se-m-t-20 se-m-b-20">
      <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          activeIndex == 0 ? 'active' : '',
        ]"
        @click="changeTab(0)"
      >
        培训计划
      </div>
      <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          activeIndex == 1 ? 'active' : '',
        ]"
        @click="changeTab(1)"
      >
        自主学习
      </div>
      <!-- <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          index === 2 ? 'active' : ''
        ]"
        @click="index = 2"
      >
        进行中
      </div>
      <div
        :class="['se-btn', 'cp', 'ft-16-333', index === 3 ? 'active' : '']"
        @click="index = 3"
      >
        待开始
      </div> -->
    </div>
    <template v-if="activeIndex == 0">
      <div class="se-list" v-loading="loading">
        <div
          class="se-item se-flex jcsb se-m-b-35"
          v-for="(item, index) in studyPlanList"
          :key="index"
          @click="goStudy(item)"
          style="cursor: pointer"
        >
          <div class="se-flex">
            <img
              :src="
                item.coverUrl || require('../../../assets/images/studyC.png')
              "
              style="width: 190px; height: 130px"
            />
            <div class="se-m-l-25">
              <div class="ft-16-333-b se-m-b-15 title">{{ item.planName }}</div>
              <div class="ft-14-999 se-m-b-5 se-flex">
                <div v-if="item.planType === '1'">
                  {{ item.endCourseCount }}/{{ item.totalCourseCount }} 课时
                </div>
                <div v-else>线下</div>
                <div class="se-p-l-10 se-p-r-10">·</div>
                {{ item.number }}次学习
              </div>
              <div class="se-flex">
                <el-rate v-model="item.star" disabled text-color="#ff9900">
                </el-rate>
                <div class="ft-14-999">{{ item.star ? item.star : 0 }}星</div>
              </div>
              <div v-if="item.planType === '1'" class="ft-14-999 se-m-t-5">
                <!-- 已学习<span class="ft-14-red"
                  >{{
                    item.totalCourseCount
                      ? (item.endCourseCount / item.totalCourseCount).toFixed(
                          2
                        ) * 100
                      : 0
                  }}%</span
                > -->
                已学习<span class="ft-14-red"
                  >{{
                    item.finishedRate ? parseInt(item.finishedRate * 100) : 0
                  }}%</span
                >
              </div>
              <div v-else class="se-m-t-5">
                {{ item.isSign === 0 ? "待签到" : "已签到" }}
              </div>
            </div>
          </div>
          <!-- <img
            src="../../../assets/icons/studyStatus1.png"
            style="width: 62px; height: 29px"
          /> -->
          <div class="course-status">
            <img
              :src="require(`../../../assets/status/${item.status}.png`)"
              alt=""
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="activeIndex == 1">
      <div class="se-list" v-loading="loadingA">
        <div
          class="se-item se-flex jcsb se-m-b-35"
          v-for="(item, i) in courseList"
          :key="i"
          @click="goCourse(item)"
          style="cursor: pointer"
        >
          <div class="se-flex">
            <img
              :src="
                item.coverUrl || require('../../../assets/images/studyC.png')
              "
              style="width: 190px; height: 130px"
            />
            <div class="se-m-l-25">
              <div class="ft-16-333-b se-m-b-15 title">
                {{ item.courseName }}
              </div>
              <div class="ft-14-999 se-m-b-5">{{ item.count }}次学习</div>
              <div class="se-flex">
                <el-rate v-model="item.star" disabled text-color="#ff9900">
                </el-rate>
                <div class="ft-14-999">{{ item.star ? item.star : 0 }}星</div>
              </div>
              <div class="ft-14-999 se-m-t-5">
                已学习<span class="ft-14-red"
                  >{{
                    item.studyRate ? parseInt(item.studyRate * 100) : 0
                  }}%</span
                >
              </div>
            </div>
          </div>
          <div class="course-status">
            <img
              :src="require(`../../../assets/status/${item.status}.png`)"
              alt=""
            />
          </div>
        </div>
      </div>
    </template>
    <div class="se-flex-h-c">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      star: 5,
      studyPlanList: [],
      courseList: [],
      pageNum: 1,
      pageSize: 6,
      total: 0,
      loading: false,
      loadingA: false,
    };
  },
  created() {
    this.getMyStudyList();
  },
  methods: {
    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      if (this.activeIndex === 0) {
        this.getMyStudyList();
      } else {
        this.getMyCourseList();
      }
    },

    goCourse(item) {
      // this.$router.push({ name: "courseInfo", query: { type: "study" } });
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "course",
          courseId: item.courseId,
          teacherId: item.teacherId,
          joinType: 2,
        },
      });
    },
    goStudy(item) {
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "study",
          planId: item.planId,
        },
      });
    },

    changeTab(index) {
      this.activeIndex = index;
      this.pageNum = 1;
      if (index == 0) {
        this.getMyStudyList();
      } else {
        this.getMyCourseList();
      }
    },
    //学习计划
    getMyStudyList() {
      this.loading = true;
      let token = localStorage.getItem("token");
      this.$http
        .get(
          "server/portal/personCenter/getStudyPlan",
          {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          this.total = res.total;
          this.studyPlanList = res.rows;
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    //课程
    getMyCourseList() {
      this.loadingA = true;
      let token = localStorage.getItem("token");
      this.$http
        .get(
          "/server/portal/personCenter/myStudyCourseList",
          {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          this.courseList = res.rows;
          this.total = res.total;
        });
      setTimeout(() => {
        this.loadingA = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.se-btn {
  width: 128px;
  height: 35px;
  border-radius: 16px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  background-color: #f6f7f9;
}

.active {
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.09);
  color: #f41539;
  background-color: #fff;
}

.course-status {
  width: 60px;
  img {
    width: 100%;
    object-fit: cover;
  }
}

.title {
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
